import React, { useState, useEffect } from "react"
import Logo from "./logo"
import NavbarLink from "./navbarLink"
import LangIcon from "./langIcon"
import Hamburger from "./hamburger"

const Header = props => {
  
  const { language, onChange, menuOptions } = props
  const [options, setOptions] = useState([])
  const [coverOption, setCoverOption] = useState({})
  const [size, setSize] = useState([1920, 0])


  useEffect(() => {
    let selectedOptions = [...menuOptions]
    setCoverOption(selectedOptions.shift())
    setOptions(selectedOptions)
    function updateSize() {
        if(window.innerWidth > 0) {
            setSize([window.innerWidth, window.innerHeight])

        }
    }
    window.addEventListener("resize", updateSize)
    updateSize()
    return () => window.removeEventListener("resize", updateSize)
  }, [menuOptions])

  const [width] = size;



  return (
    <>
      {width <= 1080 ? (
        <Hamburger
          coverOption={coverOption}
          options={options}
          language={language}
          onChange={onChange}
        />
      ) : (
        <div className={"header-container"}>
          <Logo {...coverOption} />

          <div className="header-container-items">
            {options.map((option, i) => (
              <NavbarLink key={i} {...option} />
            ))}
          </div>

          <LangIcon language={language} onChange={onChange}/>
        </div>
      )}
    </>
  )
}

export default Header
